// extracted by mini-css-extract-plugin
export var videocard = "videocard-module--videocard--7bae6";
export var videocard__image = "videocard-module--videocard__image--5bc01";
export var videocard__playicon = "videocard-module--videocard__playicon--b9fda";
export var videocard__title = "videocard-module--videocard__title--83e89";